import React, { useEffect, useState } from 'react';
import api from '../../services/api';

export default function Documentacion() {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mostrarForm, setMostrarForm] = useState(false);
  const [form, setForm] = useState({ titulo: '', descripcion: '', destinatario: 'todos', maquinista_id: '', categoria: 'otros' });
  const [archivo, setArchivo] = useState(null);
  const [maquinistas, setMaquinistas] = useState([]);
  const [guardando, setGuardando] = useState(false);
  const [acusesDoc, setAcusesDoc] = useState(null);

  useEffect(() => {
    cargar();
    api.get('/planificacion/maquinistas-disponibles').then(r => setMaquinistas(r.data)).catch(() => {});
  }, []);

  const cargar = () => {
    setLoading(true);
    api.get('/documentos/').then(r => setDocs(r.data)).finally(() => setLoading(false));
  };

  const guardar = async () => {
    if (!form.titulo || !archivo) { alert('Rellena el título y selecciona un archivo'); return; }
    setGuardando(true);
    try {
      const fd = new FormData();
      fd.append('titulo', form.titulo);
      fd.append('descripcion', form.descripcion);
      fd.append('destinatario', form.destinatario);
      fd.append('categoria', form.categoria);
      if (form.destinatario === 'personal' && form.maquinista_id) fd.append('maquinista_id', form.maquinista_id);
      fd.append('archivo', archivo);
      await api.post('/documentos/', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setMostrarForm(false);
      setForm({ titulo: '', descripcion: '', destinatario: 'todos', maquinista_id: '' });
      setArchivo(null);
      cargar();
    } catch(e) {
      alert('Error al subir el documento');
    } finally {
      setGuardando(false);
    }
  };

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar este documento?')) return;
    await api.delete(`/documentos/${id}`);
    cargar();
  };

  const verAcuses = async (doc) => {
    const r = await api.get(`/documentos/${doc.id}/acuses`);
    setAcusesDoc({ ...doc, acuses: r.data });
  };

  const destinatarioLabel = (d, nombre) => {
    if (d === 'todos') return 'Todos';
    if (d === 'lote1') return 'Lote 1';
    if (d === 'lote2') return 'Lote 2';
    if (d === 'carrileros') return 'UTE Carrileros';
    if (d === 'personal') return nombre || 'Personal';
    return d;
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
        <div>
          <h2 style={{ fontSize: 22, fontWeight: 500, margin: 0 }}>Documentación</h2>
          <p style={{ fontSize: 13, color: '#888', marginTop: 4 }}>Documentos enviados a los maquinistas</p>
        </div>
        <button onClick={() => setMostrarForm(!mostrarForm)} style={{
          padding: '9px 18px', borderRadius: 8, border: 'none', background: '#1a1a1a',
          color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 500
        }}>
          {mostrarForm ? 'Cancelar' : '+ Nuevo documento'}
        </button>
      </div>

      {mostrarForm && (
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', padding: 20, marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: 600 }}>Nuevo documento</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
            <div style={{ gridColumn: '1/-1' }}>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Título</label>
              <input value={form.titulo} onChange={e => setForm({...form, titulo: e.target.value})}
                placeholder="Título del documento..."
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
            </div>
            <div style={{ gridColumn: '1/-1' }}>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Descripción</label>
              <textarea value={form.descripcion} onChange={e => setForm({...form, descripcion: e.target.value})}
                rows={2} placeholder="Descripción opcional..."
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box', resize: 'vertical' }} />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Categoría</label>
              <select value={form.categoria} onChange={e => setForm({...form, categoria: e.target.value})}
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
                <option value="certificados">Certificados</option>
                <option value="lnm">LNM - Libro de Normas</option>
                <option value="lin">LIN - Libro de Itinerarios</option>
                <option value="otros">Otros</option>
              </select>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Destinatario</label>
              <select value={form.destinatario} onChange={e => setForm({...form, destinatario: e.target.value})}
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
                <option value="todos">Todos</option>
                <option value="lote1">Lote 1</option>
                <option value="lote2">Lote 2</option>
                <option value="carrileros">UTE Carrileros</option>
                <option value="personal">Personal (un maquinista)</option>
              </select>
            </div>
            {form.destinatario === 'personal' && (
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Maquinista</label>
                <select value={form.maquinista_id} onChange={e => setForm({...form, maquinista_id: e.target.value})}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
                  <option value="">Seleccionar...</option>
                  {maquinistas.map(m => <option key={m.id} value={m.id}>{m.nombre_completo}</option>)}
                </select>
              </div>
            )}
            <div style={{ gridColumn: '1/-1' }}>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Archivo PDF</label>
              <input type="file" accept=".pdf" onChange={e => setArchivo(e.target.files[0])}
                style={{ fontSize: 13 }} />
            </div>
          </div>
          <button onClick={guardar} disabled={guardando} style={{
            padding: '9px 20px', borderRadius: 8, border: 'none', background: '#1a1a1a',
            color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 500, opacity: guardando ? 0.6 : 1
          }}>
            {guardando ? 'Subiendo...' : 'Subir documento'}
          </button>
        </div>
      )}

      {loading ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>Cargando...</div>
      ) : (
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e5e5', overflow: 'hidden' }}>
          {docs.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>📄</div>
              <div>No hay documentos</div>
            </div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#f8f8f6' }}>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Documento</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Destinatario</th>
                  <th style={{ padding: '10px 16px', textAlign: 'center', fontWeight: 500, color: '#555' }}>Acuses</th>
                  <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Fecha</th>
                  <th style={{ padding: '10px 16px' }}></th>
                </tr>
              </thead>
              <tbody>
                {docs.map(d => (
                  <tr key={d.id} style={{ borderTop: '1px solid #f0f0f0' }}>
                    <td style={{ padding: '12px 16px' }}>
                      <div style={{ fontWeight: 500 }}>{d.titulo}</div>
                      {d.descripcion && <div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>{d.descripcion}</div>}
                      <div style={{ fontSize: 11, color: '#aaa', marginTop: 2 }}>Subido por: {d.subido_por}</div>
                    </td>
                    <td style={{ padding: '12px 16px' }}>
                      <span style={{ background: '#f0f0f0', borderRadius: 20, padding: '3px 10px', fontSize: 11 }}>
                        {destinatarioLabel(d.destinatario, d.maquinista_nombre)}
                      </span>
                    </td>
                    <td style={{ padding: '12px 16px', textAlign: 'center' }}>
                      <button onClick={() => verAcuses(d)} style={{
                        padding: '3px 10px', borderRadius: 6, border: '1px solid #ddd',
                        background: '#fff', cursor: 'pointer', fontSize: 11, color: '#555'
                      }}>
                        {d.total_acuses} acuses
                      </button>
                    </td>
                    <td style={{ padding: '12px 16px', color: '#888', fontSize: 12 }}>
                      {new Date(d.created_at).toLocaleDateString('es-ES')}
                    </td>
                    <td style={{ padding: '12px 16px' }}>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <a href={`/api/documentos/archivo/${d.archivo}`} target="_blank" rel="noreferrer"
                          style={{ padding: '3px 10px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', fontSize: 11, color: '#555', textDecoration: 'none' }}>
                          Ver PDF
                        </a>
                        <button onClick={() => eliminar(d.id)} style={{
                          padding: '3px 10px', borderRadius: 6, border: '1px solid #fcc',
                          background: '#fff5f5', cursor: 'pointer', fontSize: 11, color: '#e24b4a'
                        }}>Eliminar</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* Modal acuses */}
      {acusesDoc && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={() => setAcusesDoc(null)}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 24, width: 400, maxHeight: '80vh', overflow: 'auto' }} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 16px', fontSize: 16 }}>Acuses — {acusesDoc.titulo}</h3>
            {acusesDoc.acuses.length === 0 ? (
              <div style={{ color: '#aaa', textAlign: 'center', padding: 20 }}>Sin acuses aún</div>
            ) : acusesDoc.acuses.map((a, i) => (
              <div key={i} style={{ padding: '8px 0', borderBottom: '1px solid #f0f0f0', fontSize: 13 }}>
                <div style={{ fontWeight: 500 }}>{a.nombre} {a.apellidos}</div>
                <div style={{ fontSize: 11, color: '#888' }}>{new Date(a.fecha_acuse).toLocaleString('es-ES')}</div>
              </div>
            ))}
            <button onClick={() => setAcusesDoc(null)} style={{ marginTop: 16, width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer' }}>
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
